import { DataPointsById } from '../models/IMetricDataList';
import { MetricsDataRequestSucceededAction, MetricsDataActionTypes } from './ActionTypes';

export const metricsDataRequestSucceeded = (dataPointsById: DataPointsById): MetricsDataRequestSucceededAction => {
  return {
    type: MetricsDataActionTypes.REQUEST_SUCCEEDED,
    dataPointsById,
  };
};
